import React from 'react'

const defaultProps = {
  height: '100',
  width: '100',
}

const IconProductionLine = (props) => {
  const viewBox = `0 14 ${props.height} ${props.width}`
  return (
    <svg
      height={props.height}
      viewBox={viewBox}
      width={props.width}
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          id="iconProductionLine"
          d="M87 30.16C87 23.9965 81.9632 19 75.75 19H23.25C17.0368 19 12 23.9965 12 30.16V70.2946C12 76.4581 17.0368 81.4546 23.25 81.4546H75.75C81.9632 81.4546 87 76.4581 87 70.2946V30.16ZM23.25 22.72H75.75C79.8921 22.72 83.25 26.051 83.25 30.16V70.2946C83.25 74.4036 79.8921 77.7346 75.75 77.7346H23.25C19.1079 77.7346 15.75 74.4036 15.75 70.2946V30.16C15.75 26.051 19.1079 22.72 23.25 22.72ZM50 29C49.0031 29 48.0744 29.2917 47.2945 29.7945L46 28.5L45 25H55L54 28.5L52.7055 29.7945C51.9256 29.2917 50.9969 29 50 29ZM69 36H54.584C54.8516 35.3875 55 34.7111 55 34C55 33.2889 54.8516 32.6125 54.584 32H68C68.5523 32 69 32.4477 69 33V36ZM50 37C51.6569 37 53 35.6569 53 34C53 32.3431 51.6569 31 50 31C48.3431 31 47 32.3431 47 34C47 35.6569 48.3431 37 50 37ZM58.006 47.6571L59.0812 48.5758L59.9998 47.5006L58.9247 46.5819L58.006 47.6571ZM62 47C63.6569 47 65 45.6569 65 44C65 42.3431 63.6569 41 62 41C60.3431 41 59 42.3431 59 44C59 45.6569 60.3431 47 62 47ZM62 45.5C62.8284 45.5 63.5 44.8284 63.5 44C63.5 43.1716 62.8284 42.5 62 42.5C61.1716 42.5 60.5 43.1716 60.5 44C60.5 44.8284 61.1716 45.5 62 45.5ZM62.8477 40.017C64.2021 40.1502 65.3299 41.0556 65.7849 42.2871L69.0002 38H64.0002L62.8477 40.017ZM53.749 49H43.928C43.3416 49 42.7848 49.2573 42.4048 49.7038L38.8033 53.9362C38.6133 54.1595 38.3349 54.2881 38.0417 54.2881H35.3718C34.547 54.2881 33.8068 54.7944 33.5078 55.563L31.5338 60.6374C31.2788 61.293 31.7624 62 32.4658 62H35.9996C35.9996 59.7909 37.7905 58 39.9996 58C42.2088 58 43.9996 59.7909 43.9996 62H56.9996C56.9996 59.7909 58.7905 58 60.9996 58C63.2088 58 64.9996 59.7909 64.9996 62L65.4445 62H68.0038C68.5561 62 69.0038 61.5523 69.0038 61V57.0752C69.0038 56.81 68.8984 56.5556 68.7109 56.3681L67.2167 54.8739C66.8416 54.4988 66.3329 54.2881 65.8025 54.2881H60.8896C60.6464 54.2881 60.4115 54.1995 60.229 54.0388L55.0704 49.4987C54.7052 49.1773 54.2355 49 53.749 49ZM25.3457 66C24.5173 66 23.8457 66.6716 23.8457 67.5C23.8457 68.3284 24.5173 69 25.3457 69H73.4995C74.3279 69 74.9995 68.3284 74.9995 67.5C74.9995 66.6716 74.3279 66 73.4995 66H25.3457ZM21.8457 67.5C21.8457 65.567 23.4127 64 25.3457 64H73.4995C75.4325 64 76.9995 65.567 76.9995 67.5C76.9995 69.433 75.4325 71 73.4995 71H25.3457C23.4127 71 21.8457 69.433 21.8457 67.5Z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h100v100H0z" />
        <g transform="translate(0 15)">
          <use
            fill="#FFFFFF"
            fillRule="nonzero"
            xlinkHref="#iconProductionLine"
          />
        </g>
      </g>
    </svg>
  )
}

IconProductionLine.defaultProps = defaultProps

export default IconProductionLine
